import { RootState, useSelector } from '@tabeeb/store'
import { getUserById } from '../selectors'
import { PluginUser } from '../types'

export function useUserById(id?: number): PluginUser | undefined {
  return useSelector((state: RootState) => (id !== undefined ? getUserById(state, { Id: id }) : undefined))
}

export default useUserById
